import gsap from "gsap";
import Header from "./header";


const ColumnImages = (() => {

    const SELECTOR_MODULE = '.module-container__2-col-images';


    const initialize = () => {

        const module = document.querySelector(SELECTOR_MODULE);

        initAnimations(module);
    }

    const initAnimations = (module) => {

        if (!module) return;

        // animated elements

        const pictures = module.querySelectorAll(`picture`);


        // animation timeline
        const tl = gsap.timeline({
            scrollTrigger: {
                trigger: module,
                start: 'top bottom',
                end: "bottom bottom",
                /* pin: true, */
                scrub: 1,
                /* once: false, */
                /* markers: true, */
                invalidateOnRefresh: true,
            }
        })
            .fromTo(pictures[0],
                { top: "-60%" },
                { top: "-40%", ease: "none", duration: 2 }, 
            )
            .fromTo(pictures[1],
                { top: "-40%" },
                { top: "-20%", ease: "none", duration: 2 },
                "<" 
            )
            /* .to({}, { duration: 2 }) */


    };



    return {
        initialize
    }

})();


export default ColumnImages;